/**
 * HNB-575 — Nerdy Form embeds render visible <label>s without for=,
 * plus empty heading/label nodes. Wire labels to controls after render.
 */
(function () {
  if (window._mfrA11yNerdyForm) return;
  window._mfrA11yNerdyForm = true;

  function fixForm(form) {
    if (!(form instanceof Element) || form.getAttribute('data-mfr-a11y-labels') === '1') {
      return;
    }

    form.querySelectorAll('[id^="nf-container-"]').forEach(function (container) {
      var control = container.querySelector(
        'input:not([type="hidden"]), select, textarea'
      );
      if (!control) return;

      if (!control.id) {
        control.id =
          'nf-a11y-' + (control.name || 'field') + '-' + Math.random().toString(36).slice(2, 8);
      }

      var labels = Array.prototype.slice.call(container.querySelectorAll('label'));
      var fallback =
        control.getAttribute('placeholder') ||
        control.getAttribute('aria-label') ||
        (control.type === 'file' ? 'File upload' : '') ||
        control.name ||
        'Field';

      // Prefer an existing wired label (e.g. Nerdy .nf-file-label). Avoid
      // WAVE "Multiple form labels" by associating only one label per control.
      var primary =
        container.querySelector('label[for="' + control.id + '"]') ||
        labels[0] ||
        null;

      labels.forEach(function (label) {
        if (label === primary) {
          if (!label.getAttribute('for')) {
            label.setAttribute('for', control.id);
          }
          if (!(label.textContent || '').trim()) {
            label.textContent = fallback;
          }
          return;
        }

        // Extra empty field labels (common above file inputs) — remove.
        if (!(label.textContent || '').trim()) {
          label.remove();
          return;
        }

        // Keep visible helper text, but do not associate a second label.
        label.removeAttribute('for');
        label.setAttribute('aria-hidden', 'true');
      });

      // Do not also set aria-label when a <label for> exists — WAVE flags
      // that as "Multiple form labels".
      if (!container.querySelector('label[for="' + control.id + '"]') && !control.getAttribute('aria-label')) {
        var nameText = (primary && primary.textContent ? primary.textContent : '').trim() || fallback;
        if (nameText) control.setAttribute('aria-label', nameText);
      }
    });

    form.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
      if (!(heading.textContent || '').trim()) {
        heading.setAttribute('aria-hidden', 'true');
        heading.setAttribute('role', 'presentation');
        // WAVE still flags empty headings in the tree — remove if truly empty.
        heading.remove();
      }
    });

    form.setAttribute('data-mfr-a11y-labels', '1');
  }

  function scan(root) {
    (root || document).querySelectorAll('form.nf-form, form[id^="nerdy-form-"]').forEach(fixForm);
  }

  function observe() {
    scan(document);
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!(node instanceof Element)) continue;
          if (node.matches && (node.matches('form.nf-form') || node.matches('form[id^="nerdy-form-"]'))) {
            fixForm(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
